module.exports = __webpack_public_path__ + "img/user-06.e2faac12.jpg";